import { j as c } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as s } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const t = s((e, a) => /* @__PURE__ */ c.jsx(
  r,
  {
    ref: a,
    ...e,
    image: (o) => /* @__PURE__ */ c.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...o,
        children: /* @__PURE__ */ c.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M5 10a3 3 0 0 0-2.995 3.169c.063 1.133.654 2.227 1.246 3.322C3.876 17.646 4.5 18.8 4.5 20c0 1.197-.624 2.353-1.25 3.509-.59 1.094-1.182 2.188-1.245 3.321a3 3 0 1 0 5.99 0c-.062-1.133-.654-2.227-1.246-3.322C6.124 22.354 5.5 21.2 5.5 20c0-1.197.624-2.353 1.25-3.509.59-1.094 1.182-2.188 1.245-3.32A3 3 0 0 0 5 10m5.5-7a3 3 0 0 0-2.995 3.169c.063 1.133.654 2.227 1.246 3.321C9.376 10.646 10 11.802 10 13s-.624 2.354-1.25 3.51c-.59 1.094-1.182 2.188-1.245 3.321a3 3 0 1 0 5.99 0c-.063-1.133-.654-2.227-1.246-3.322C11.624 15.355 11 14.2 11 13c0-1.197.624-2.353 1.25-3.509.59-1.094 1.182-2.188 1.245-3.32q.005-.085.005-.17a3 3 0 0 0-3-3M27 10a3 3 0 0 0-2.995 3.169c.063 1.133.654 2.227 1.246 3.322.625 1.155 1.249 2.31 1.249 3.51 0 1.197-.624 2.353-1.25 3.509-.59 1.094-1.182 2.188-1.245 3.321a3 3 0 1 0 5.99 0c-.062-1.133-.654-2.227-1.246-3.322C28.125 22.354 27.5 21.2 27.5 20c0-1.197.624-2.353 1.25-3.509.59-1.094 1.182-2.188 1.245-3.32A3 3 0 0 0 27 10m-14 3a3 3 0 1 1 5.995.17c-.063 1.132-.654 2.226-1.246 3.32-.625 1.156-1.249 2.312-1.249 3.51s.625 2.354 1.25 3.51c.59 1.094 1.183 2.188 1.245 3.321Q19 26.915 19 27a3 3 0 1 1-5.995-.169c.063-1.133.654-2.227 1.246-3.321.625-1.156 1.249-2.312 1.249-3.51s-.624-2.354-1.25-3.51c-.59-1.094-1.182-2.188-1.245-3.321A3 3 0 0 1 13 13m5.5-7a3 3 0 1 1 5.995.17c-.063 1.132-.654 2.226-1.246 3.32C22.624 10.646 22 11.802 22 13s.625 2.354 1.25 3.51c.59 1.094 1.183 2.188 1.245 3.321q.005.084.005.169a3 3 0 1 1-5.995-.169c.063-1.133.654-2.227 1.246-3.321C20.376 15.354 21 14.198 21 13s-.624-2.354-1.25-3.51c-.59-1.094-1.183-2.188-1.245-3.321A3 3 0 0 1 18.5 6",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
t.displayName = "TextureIcon";
export {
  t as TextureIcon,
  t as default
};
//# sourceMappingURL=index.js.map
